import {Observable} from "rxjs";
import {Injectable} from "@angular/core";

import * as _ from "lodash";

import {URLSearchParams} from '@angular/http'
import {HttpBackendService} from "app/services/http-backend.service";
import {PagedResult} from "app/models/PagedResult";
import {AssetService} from "app/services/asset.service";
import { ServiceObject, ServiceObjectBase } from "app/models/serviceObject";
import { Asset } from "app/models/asset";
import { ServiceAreaService } from "./serviceArea.service";

@Injectable()
export class ServiceObjectService {

  constructor(
    private _http: HttpBackendService
  ) { }

  public getServiceObjectsPerPage(sortBy: string, isDesc: boolean, count: number, skip: number): Observable<PagedResult<ServiceObject>> {
    let params = new URLSearchParams;
    let filterRequestStrings: string[] = new Array();

    params.append('$filter', "IsDeleted eq false and Parent eq null");
    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$select', "Id,Name,Address,IsOnService,Longitude,Latitude,ServiceObjectType");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");

    return this._http.get("/api/odata/serviceObjects", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<ServiceObject>();

        result.items = _.map(pagedResult.value, function (value) {
          return ServiceObjectService.convertServiceObjectDTO2Object(value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
  }

  public getServiceObjectIdsWithOpenCall(): Observable<number[]> {

    return this._http.get("/api/serviceObject/getserviceobjectsidwithopencallinfo")
      .map(resp => {
        return _.map(resp.json(), value => value as number);
      });
  }

  public getServiceObjectIdsWithPlannedService(): Observable<number[]> {

    return this._http.get("/api/serviceObject/getserviceobjectsidwithplannedservice")
      .map(resp => {
        return _.map(resp.json(), value => value as number);
      });
  }

  public getServiceObjectsByName(name: string): Observable<ServiceObject[]> {
    let params = new URLSearchParams;
    params.append('$filter', `IsDeleted eq false and (contains(tolower(Name), '${name.toLocaleLowerCase()}') or contains(tolower(Address), '${name.toLocaleLowerCase()}'))`);
    params.append('$select', "Id,Name,Address,ServiceObjectType");

    return this._http.get("/api/odata/serviceObjects", params, true)
      .map(resp => {
        let result = _.map(resp.json().value, function (value) {
          return ServiceObjectService.convertServiceObjectDTO2Object(value);
        });

        return result;
      });
  }

  public getServiceObjects(): Observable<ServiceObject[]> {
    let params = new URLSearchParams;
    params.append('$filter', "IsDeleted eq false");
    params.append('$select', "Id,Name");

    return this._http.get("/api/odata/serviceObjects", params, true)
      .map(resp => {
        let result = _.map(resp.json().value, function (value) {
          return ServiceObjectService.convertServiceObjectDTO2Object(value);
        });

        return result;
      });
  }

  public getServiceObjectDetails(id: number): Observable<ServiceObject> {
    let params = new URLSearchParams;
    params.append('$select', "Id,Name,Address,IsOnService,Longitude,Latitude,IsDeleted");
    params.append('$expand', "AttachedServiceArea,Children($filter=IsDeleted eq false;$orderby=Name asc)");

    return this._http.get("/api/odata/serviceObjects(" + id + ")", params, true)
      .map(resp => {
        return ServiceObjectService.convertServiceObjectDTO2Object(resp.json())
      });
  }

  public getServiceObjectAddress(id: number): Observable<string> {
    let params = new URLSearchParams;
    params.append('$select', "Address");

    return this._http.get("/api/odata/serviceObjects(" + id + ")", params, true)
      .map(resp => {
        return resp.json().Address;
      });
  }

  public getServiceObjectPath(id: number): Observable<ServiceObjectBase[]> {
    return this._http.get("/api/serviceObject/" + id + "/getserviceobjectpath", null, true)
      .map(resp => {
        let result: ServiceObjectBase[] = [];

        resp.json().forEach(value => {
          var serviceObject = ServiceObjectService.convertServiceObjectDTO2Object(value);
          result.push(serviceObject);
        });
        return result;
      });
  }

  public getChildrenForParentId(parentId: number, sortBy: string, isDesc: boolean, count: number, skip: number): Observable<PagedResult<ServiceObject>> {
    let params = new URLSearchParams;

    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$expand', "Parent($select=Id)");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");
    params.append('$filter', "IsDeleted eq false and Parent/Id eq " + parentId);
    params.append('$select', "Id,Name,Address,IsOnService,Longitude,Latitude,ServiceObjectType,ClientPersonalArea.Web.Domain.Model.Asset/Status");


    return this._http.get("/api/odata/serviceObjects", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<ServiceObject>();

        result.items = _.map(pagedResult.value, function (value) {
          return ServiceObjectService.convertServiceObjectDTO2Object(value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
    }
}

export namespace ServiceObjectService {
  export function convertServiceObjectDTO2Object(dto: any, serviceObject: ServiceObject = new ServiceObject()): ServiceObject {
    serviceObject.id = dto.Id;
    serviceObject.name = dto.Name;
    serviceObject.address = dto.Address;
    serviceObject.isOnService = dto.IsOnService;
    serviceObject.isDeleted = dto.IsDeleted;
    serviceObject.latitude = dto.Latitude;
    serviceObject.longitude = dto.Longitude;
    serviceObject.type = dto.ServiceObjectType != null ? dto.ServiceObjectType.Name : "-";

    if(dto.AttachedServiceArea != null)
      serviceObject.serviceArea = ServiceAreaService.convertServiceAreaDTO2Object(dto.AttachedServiceArea);

    const discriminator = dto['@odata.type'];
    if (discriminator)
      serviceObject.discriminator = discriminator.split('.').pop();

    if (serviceObject.discriminator == 'Asset')
      (serviceObject as Asset).status = dto.Status;

    serviceObject.children = _.map(dto.Children, function (value) {
      return ServiceObjectService.convertServiceObjectDTO2Object(value);
    });

    return serviceObject;
  };
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/serviceObject.service.ts